// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__15_JW","inner":"Footer_inner__3Ev5i","nextIcon":"Footer_nextIcon__21Uff","innerLeft":"Footer_innerLeft__3u5lT"};